import { render } from "./BindYh.vue?vue&type=template&id=514ac619&scoped=true"
import script from "./BindYh.vue?vue&type=script&lang=js"
export * from "./BindYh.vue?vue&type=script&lang=js"

import "./BindYh.vue?vue&type=style&index=0&id=514ac619&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514ac619"]])

export default __exports__